import TrendingTopics from './TrendingTopics';
import SuggestedCreators from './SuggestedCreators';
import IntentGraphWidget from './IntentGraphWidget';

export default function FeedRightPanel() {
  return (
    <div className="space-y-4 sticky top-20">
      <IntentGraphWidget />
      <TrendingTopics />
      <SuggestedCreators />
    </div>
  );
}